import { Box } from '@material-ui/core';
import React, { memo } from 'react';
import RequestCommentSection from './RequestCommentSection';
import './RequestComment.css';

const RequestComment = (
    { handleCurrentTreatmentPlan, currentTreatmentPlan, handleApproveTreatmentPlanByCaseType, treatmentPlans, patientInfo, }
) => {
    return (
        <Box display="flex" flexDirection="column" overflow="auto" >
            <RequestCommentSection
                handleCurrentTreatmentPlan={handleCurrentTreatmentPlan}
                currentTreatmentPlan={currentTreatmentPlan}
                handleApproveTreatmentPlanByCaseType={handleApproveTreatmentPlanByCaseType}
                treatmentPlans={treatmentPlans}
                patientInfo={patientInfo}
            />
        </Box>
    );
};

export default memo(RequestComment);
